/* GLITTER GURL theme JS ✦ cart drawer + shade swap + upsell + PDP logic */
(function () {
  /**
   * Shades withdrawn from sale, from layout/theme.liquid. The cart
   * drawer fetches /products/<handle>.js, which is Shopify's own data
   * and includes every variant, so a shade hidden on the product page
   * was still pickable from the bag.
   */
  var RETIRED = (window.GG_RETIRED || []).map(function (s) {
    return String(s).trim().toLowerCase();
  });
  function isRetired(title) {
    return RETIRED.indexOf(String(title || '').trim().toLowerCase()) >= 0;
  }

  /** The $0 placeholder that stands in for the free gift over $60. */
  var GIFT_VARIANT = 46350770241671;
  'use strict';
  var GG = window.GG || { money: function (c) { return '$' + c / 100; } };
  var GURL_MATH_HANDLES = ['jelly-glow-eyeshadow', 'glitter-jelly-lip-gloss', 'lip-stain-marker'];
  // Every shade product, not the original three. Mascara and Eyeliner are
  // the two dearest singles and were invisible to every cart upsell.
  var CORE_HANDLES = ['jelly-glow-eyeshadow', 'glitter-jelly-lip-gloss', 'lip-stain-marker',
                      'glitter-eyeliner', 'glitter-mascara', 'multichrome-eyeshadow-stick'];

  /* ── cart ─────────────────────────────────────── */
  var cartState = null;
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(); return c; });
  }
  window.__ggCartRefresh = fetchCart;
  function addItemsRaw(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r;
    });
  }
  function addItems(items) { return addItemsRaw(items).then(function () { return fetchCart(); }); }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(); });
  }
  function swapVariant(item, newId) {
    addItemsRaw([{ id: newId, quantity: item.quantity }]).then(function () {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }).then(function () { return fetchCart(); }).catch(function () { fetchCart(); });
  }

  // ggBN cart line: pay for N, get N free from 2 paid, up to 5 free. The gift line never counts.
  function bnCartText(c) {
    var n = 0;
    (c.items || []).forEach(function (it) { if (it.variant_id !== GIFT_VARIANT) n += it.quantity; });
    if (!n) return '';
    if (window.GG_BN_NEXT) {
      var st = window.GG_BN_NEXT(n), url = window.GG_BN_BUILD || '/pages/build-your-bag';
      return (st.warn ? '⚠️ <b>' + st.warn + '</b><br>' : '') + st.line + (st.done ? '' : ' <a href="' + url + '">build your bag →</a>');
    }
    var free = n >= 4 ? Math.min(Math.floor(n / 2), 5) : 0;
    if (n < 4) return 'add ' + (4 - n) + ' more ✦ and 2 of them are <b>free</b>';
    if (free >= 5) return '<b>5 free</b> unlocked ✦ the most per order, gurl';
    if (n % 2) return '<b>' + free + ' free</b> unlocked ✦ add 1 more and it\'s <b>free</b>';
    return '<b>' + free + ' free</b> unlocked ✦ add 2 more, 1 of them is <b>free</b>';
  }
  function renderCart() {
    var c = cartState; if (!c) return;
    var bnEl = document.getElementById('gg-bn-cart');
    if (bnEl) { var bnT = window.GG_BN ? bnCartText(c) : ''; bnEl.hidden = !bnT; bnEl.innerHTML = bnT; }
    var badge = document.getElementById('gg-bag-count');
    if (badge) { badge.textContent = c.item_count; badge.hidden = c.item_count === 0; }
    if (window.__ggAnnounceRefresh) window.__ggAnnounceRefresh();
    var body = document.getElementById('gg-drawer-body');
    var upsellEl = document.getElementById('gg-upsell');
    var foot = document.getElementById('gg-drawer-foot');
    var title = document.getElementById('gg-drawer-count');
    if (title) title.textContent = '(' + c.item_count + ')';
    if (!body) return;
    if (c.item_count === 0) {
      body.innerHTML = '<div class="gg-drawer-empty">' +
        '<svg viewBox="0 0 24 24" style="width:20px;height:20px"><path d="M12 0 L14.4 9.6 L24 12 L14.4 14.4 L12 24 L9.6 14.4 L0 12 L9.6 9.6 Z" fill="#C59A4C"></path></svg>' +
        '<div style="font-size:14px;font-weight:600;letter-spacing:.06em">your bag is empty, gurl</div>' +
        '<a href="/collections/all" style="font-size:11px;letter-spacing:.2em;text-transform:uppercase;text-decoration:underline;text-underline-offset:3px">shop the sparkle →</a></div>';
      if (upsellEl) upsellEl.innerHTML = '';
      if (foot) foot.hidden = true;
      return;
    }
    var shop = (window.GG_SHOP && window.GG_SHOP.products) || {};
    var needed = {};
    c.items.forEach(function (it) { if (!shop[it.handle]) needed[it.handle] = 1; });
    Promise.all(Object.keys(needed).map(getProduct)).then(function (prods) {
      var byHandle = {};
      prods.forEach(function (p) { if (p) byHandle[p.handle] = p; });
      buildRows(c, byHandle, body, shop);
      buildFoot(c, foot);
    }).catch(function (e) {
      console.error('[GlitterGurl] drawer render failed', e);
      buildRows(c, {}, body, {});
      buildFoot(c, foot);
    });
  }

  function removeLines(keys) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(); });
  }

  function isOut(v) { return !!v && v.available === false; }

  // The live offer ladder, in cents. Tier two is "any 3 for trio" and it
  // applies ONCE per cart, so a fourth loose shade is charged full price.
  // On eyeshadow that makes four loose shades dearer than the set of five,
  // which is why the nudge below compares instead of guessing.
  var GURL_OFFERS = {
    'jelly-glow-eyeshadow':    { one: 1500, trio: 3500, all: 5000, allQty: 5 },
    'lip-stain-marker':        { one: 1700, trio: 4000, all: 6000, allQty: 5 },
    'glitter-jelly-lip-gloss': { one: 1800, trio: 4000, all: 7000, allQty: 6 },
    'glitter-eyeliner':        { one: 1900, trio: 4500, all: 6500, allQty: 5 },
    'glitter-mascara':         { one: 2200, trio: 5500, all: 7500, allQty: 5 },
    'multichrome-eyeshadow-stick': { one: 2100, trio: 5500, all: 8500, allQty: 6 },
  };
  var TIER_QTY = [1, 3, 6];
  function bnPaid(c) {
    var live = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
    return (window.GG_BN && !live && window.GG_BN_CART_CALC) ? window.GG_BN_CART_CALC(c).pay : (c.total_price || 0);
  }
  var BN_NOUN = {
    'jelly-glow-eyeshadow': ['jelly glow', 'jelly glows'], 'glitter-jelly-lip-gloss': ['gloss', 'glosses'],
    'lip-stain-marker': ['marker', 'markers'], 'glitter-mascara': ['mascara', 'mascaras'],
    'glitter-eyeliner': ['eyeliner', 'eyeliners'], 'multichrome-eyeshadow-stick': ['stick', 'sticks']
  };

  function buildRows(c, byHandle, body, shop) {
    body.innerHTML = '';
    var order = [], groups = {};
    c.items.forEach(function (it) {
      var lk = it.properties && it.properties._look;
      var key = lk ? 'k:' + lk : (shop[it.handle] ? 'g:' + it.handle : 'l:' + it.key);
      if (!groups[key]) { groups[key] = []; order.push(key); }
      groups[key].push(it);
    });
    order.forEach(function (key) {
      if (key.indexOf('k:') === 0) {
        buildLookCard(groups[key], body, shop);
      } else if (key.indexOf('g:') === 0) {
        buildGroupCard(key.slice(2), groups[key], body, shop);
      } else {
        buildPlainLine(groups[key][0], byHandle, body);
      }
    });
    var inCart = {};
    c.items.forEach(function (it) { inCart[it.handle] = 1; });
    var missing = CORE_HANDLES.filter(function (h) { return !inCart[h] && shop[h]; });
    if (missing.length) {
      var label = document.createElement('div');
      label.className = 'gg-discover-label';
      label.textContent = 'you might also love ✦';
      body.appendChild(label);
      missing.forEach(function (h) { buildDiscoverCard(h, body, shop); });
    }
  }

  // The Look: six real products she built as one set, shown as one card.
  // The stepper adds or removes whole sets; "edit shades" opens the six rows
  // and any row can swap its shade in place, staying inside the set.
  var GG_LOOK_OPEN = {};
  function lookPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function lookRefresh() { return window.__ggCartRefresh ? window.__ggCartRefresh() : null; }
  function buildLookCard(items, body, shop) {
    var lookId = items[0].properties._look;
    var ORDER = ['jelly-glow-eyeshadow', 'multichrome-eyeshadow-stick', 'glitter-eyeliner', 'glitter-mascara', 'lip-stain-marker', 'glitter-jelly-lip-gloss'];
    items = items.slice().sort(function (a, b) { return ORDER.indexOf(a.handle) - ORDER.indexOf(b.handle); });
    var sets = items.reduce(function (m, it) { return Math.min(m, it.quantity); }, 99);
    var was = 0, now = 0;
    items.forEach(function (it) { was += it.original_line_price; now += it.final_line_price; });
    var open = !!GG_LOOK_OPEN[lookId];

    var card = document.createElement('div');
    card.className = 'gg-group gg-look-card';
    var top = document.createElement('div');
    top.className = 'gg-group-top';
    var chips = items.map(function (it) {
      var cfg = shop[it.handle], v = cfg && cfg.variants.filter(function (x) { return x.title === it.variant_title; })[0];
      return '<span style="' + (v && v.chip ? "background-image:url('" + v.chip + "')" : '') + '"></span>';
    }).join('');
    top.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0752/8067/9047/files/the-look-group-v2.jpg?width=200" alt="">' +
      '<div class="gg-line-info"><div class="gg-line-name">The Look' + (sets > 1 ? ' &times;' + sets : '') + '</div>' +
      '<div class="gg-line-shade">6 products ✦ your shades</div>' +
      '<div class="gg-look-price">' + (was > now ? '<s>' + GG.money(was) + '</s> ' : '') + GG.money(now) + '</div></div>' +
      '<button type="button" class="gg-look-x" aria-label="remove the look">✕</button>';
    card.appendChild(top);

    var bar = document.createElement('div');
    bar.className = 'gg-look-bar';
    bar.innerHTML = '<span class="gg-look-dots">' + chips + '</span>' +
      '<span class="gg-look-step"><button type="button" class="gg-sbtn" data-l="-">–</button><b>' + sets + '</b><button type="button" class="gg-sbtn plus" data-l="+">+</button></span>' +
      '<button type="button" class="gg-look-edit">' + (open ? 'done' : 'edit shades') + ' ' + (open ? '▴' : '▾') + '</button>';
    card.appendChild(bar);

    if (open) {
      var list = document.createElement('div');
      list.className = 'gg-look-list';
      items.forEach(function (it) {
        var cfg = shop[it.handle];
        var cur = cfg && cfg.variants.filter(function (x) { return x.title === it.variant_title; })[0];
        var row = document.createElement('div');
        row.className = 'gg-look-row';
        row.innerHTML = '<span class="s-icon"' + (cur && cur.chip ? " style=\"background-image:url('" + cur.chip + "')\"" : '') + '></span>' +
          '<span class="gg-look-p">' + (cfg ? cfg.title : it.product_title) + '</span>' +
          '<button type="button" class="gg-look-s">' + it.variant_title + ' <i>change ▾</i></button>';
        list.appendChild(row);
        var pick = document.createElement('div');
        pick.className = 'gg-look-pick';
        pick.hidden = true;
        (cfg ? cfg.variants : []).forEach(function (v) {
          var c = document.createElement('button');
          c.type = 'button';
          c.className = 'gg-chip' + (v.title === it.variant_title ? ' on' : '') + (isOut(v) ? ' is-out' : '');
          c.innerHTML = (v.chip ? '<span class="c-img" style="background-image:url(' + v.chip + ')"></span>' : '') + '<span>' + v.title + '</span>';
          c.addEventListener('click', function () {
            if (isOut(v) || v.title === it.variant_title) return;
            c.disabled = true;
            lookPost('/cart/change.js', { id: it.key, quantity: 0 })
              .then(function () { return lookPost('/cart/add.js', { items: [{ id: v.id, quantity: it.quantity, properties: it.properties }] }); })
              .then(lookRefresh, lookRefresh);
          });
          pick.appendChild(c);
        });
        list.appendChild(pick);
        row.querySelector('.gg-look-s').addEventListener('click', function () { pick.hidden = !pick.hidden; });
      });
      card.appendChild(list);
    }

    function setAll(q) {
      var updates = {};
      items.forEach(function (it) { updates[it.key] = q; });
      return lookPost('/cart/update.js', { updates: updates }).then(lookRefresh, lookRefresh);
    }
    top.querySelector('.gg-look-x').addEventListener('click', function () { setAll(0); });
    bar.querySelector('[data-l="-"]').addEventListener('click', function () { setAll(sets - 1); });
    bar.querySelector('[data-l="+"]').addEventListener('click', function () { setAll(sets + 1); });
    bar.querySelector('.gg-look-edit').addEventListener('click', function () {
      GG_LOOK_OPEN[lookId] = !GG_LOOK_OPEN[lookId];
      var fresh = document.createElement('div');
      body.replaceChild(fresh, card);
      var tmp = document.createElement('div');
      buildLookCard(items, tmp, shop);
      body.replaceChild(tmp.firstChild, fresh);
    });
    body.appendChild(card);
  }

  // A quick look at one shade from inside the bag. It sits over the bag,
  // never navigates away, and closes back to exactly where she was.
  function openPeek(cfg, v) {
    var drawer = document.getElementById('gg-drawer'); if (!drawer) return;
    var old = document.getElementById('gg-peek'); if (old) old.remove();
    var imgs = (v.gallery && v.gallery.length) ? v.gallery : (v.chip ? [v.chip] : []);
    var i = 0;
    var wrap = document.createElement('div'); wrap.id = 'gg-peek';
    wrap.innerHTML = '<div class="gg-peek-card" role="dialog" aria-label="' + cfg.title + ' in ' + v.title + '">' +
      '<button type="button" class="gg-peek-x" aria-label="close">✕</button>' +
      '<div class="gg-peek-img"></div>' +
      '<div class="gg-peek-dots"></div>' +
      '<div class="gg-peek-name">' + cfg.title + ' <b>' + v.title + '</b></div>' +
      '<div class="gg-peek-actions">' +
      (isOut(v) ? '<span class="gg-peek-out">sold out</span>' : '<button type="button" class="gg-btn gg-peek-add">add ✦ ' + GG.money(cfg.price) + '</button>') +
      '<button type="button" class="gg-peek-back">back to bag</button></div></div>';
    var imgEl = wrap.querySelector('.gg-peek-img'), dots = wrap.querySelector('.gg-peek-dots');
    function show() {
      // gallery items are image urls, or {src, video} for a clip: play clips muted on a loop
      var it = imgs[i], src = it && typeof it === 'object' ? it.src : it, vid = it && typeof it === 'object' ? it.video : null;
      imgEl.style.backgroundImage = src ? "url('" + src + "')" : '';
      var oldV = imgEl.querySelector('video.gg-peek-video'); if (oldV) oldV.remove();
      if (vid) {
        var ve = document.createElement('video');
        ve.className = 'gg-peek-video'; ve.src = vid; ve.muted = true; ve.loop = true; ve.autoplay = true;
        ve.setAttribute('playsinline', ''); ve.setAttribute('muted', ''); ve.poster = src || '';
        imgEl.insertBefore(ve, imgEl.firstChild);
        var pr = ve.play(); if (pr && pr.catch) pr.catch(function () {});
      }
      dots.innerHTML = '';
      imgs.forEach(function (_, k) {
        var d = document.createElement('button'); d.type = 'button'; if (k === i) d.className = 'on';
        d.setAttribute('aria-label', 'image ' + (k + 1));
        d.addEventListener('click', function () { i = k; show(); });
        dots.appendChild(d);
      });
    }
    var x0 = null;
    imgEl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    imgEl.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 30) { i = (i + (dx < 0 ? 1 : -1) + imgs.length) % imgs.length; show(); }
    });
    imgEl.addEventListener('click', function (e) {
      if (imgs.length < 2) return;
      var r = imgEl.getBoundingClientRect(); i = (i + (e.clientX - r.left > r.width / 2 ? 1 : -1) + imgs.length) % imgs.length; show();
    });
    function close() { wrap.remove(); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    wrap.querySelector('.gg-peek-x').addEventListener('click', close);
    wrap.querySelector('.gg-peek-back').addEventListener('click', close);
    var add = wrap.querySelector('.gg-peek-add');
    if (add) add.addEventListener('click', function () { add.disabled = true; add.textContent = 'added ✦'; addItems([{ id: v.id, quantity: 1 }]).then(close, close); });
    show();
    drawer.appendChild(wrap);
  }
  function peekable(nameEl, cfg, v) {
    nameEl.classList.add('peek');
    nameEl.setAttribute('role', 'button'); nameEl.setAttribute('tabindex', '0');
    nameEl.setAttribute('aria-label', 'see ' + v.title + ' up close');
    nameEl.addEventListener('click', function (e) { e.stopPropagation(); openPeek(cfg, v); });
    nameEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') openPeek(cfg, v); });
  }

  function buildDiscoverCard(handle, body, shop) {
    var cfg = shop[handle];
    var card = document.createElement('div');
    card.className = 'gg-group gg-discover';
    var top = document.createElement('div');
    top.className = 'gg-group-top';
    top.style.cursor = 'pointer';
    top.innerHTML =
      (cfg.image ? '<img src="' + cfg.image + '" alt="">' : '') +
      '<div class="gg-line-info"><div class="gg-line-name">' + cfg.title + '</div>' +
      // Was hardcoded to five, so the six shade marker and stick both lied.
      '<div class="gg-line-shade">' + GG.money(cfg.price) + ' · ' + cfg.variants.length + ' shades</div></div>' +
      '<span class="gg-disc-toggle">▾</span>';
    card.appendChild(top);
    var list = null;
    top.addEventListener('click', function () {
      if (list) { card.removeChild(list); list = null; top.querySelector('.gg-disc-toggle').textContent = '▾'; return; }
      list = document.createElement('div');
      list.className = 'gg-shade-list';
      cfg.variants.forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'gg-shade-row';
        var icon = document.createElement('span');
        icon.className = 's-icon';
        if (v.chip) icon.style.backgroundImage = "url('" + v.chip + "')";
        var name = document.createElement('span');
        name.className = 's-name';
        name.textContent = v.title;
        peekable(name, cfg, v);
        row.appendChild(icon); row.appendChild(name);
        if (isOut(v)) {
          row.classList.add('soldout');
          var tag = document.createElement('span');
          tag.className = 's-out';
          tag.textContent = 'sold out';
          row.appendChild(tag);
        } else {
          var plus = document.createElement('button');
          plus.type = 'button';
          plus.className = 'gg-sbtn plus';
          plus.textContent = '+';
          plus.setAttribute('aria-label', 'add ' + cfg.title + ' in ' + v.title);
          plus.addEventListener('click', function (e) {
            e.stopPropagation();
            plus.disabled = true;
            addItems([{ id: v.id, quantity: 1 }]);
          });
          row.appendChild(plus);
        }
        list.appendChild(row);
      });
      card.appendChild(list);
      top.querySelector('.gg-disc-toggle').textContent = '▴';
    });
    body.appendChild(card);
  }

  var ggCollapsed = {};
  function buildGroupCard(handle, items, body, shop) {
    var cfg = shop[handle];
    var totalQty = 0, totalPrice = 0;
    var byVariant = {};
    items.forEach(function (it) {
      totalQty += it.quantity;
      totalPrice += it.final_line_price;
      byVariant[it.variant_id] = it;
    });
    var card = document.createElement('div');
    card.className = 'gg-group';
    var top = document.createElement('div');
    top.className = 'gg-group-top';
    top.innerHTML =
      (cfg.image ? '<img src="' + cfg.image + '" alt="">' : '') +
      '<div class="gg-line-info">' +
      '<div class="gg-line-name">' + cfg.title + '</div>' +
      '<div class="gg-line-shade">' + totalQty + ' in your bag</div>' +
      '<div style="font-size:12px;font-weight:600;margin-top:2px">' + GG.money(totalPrice) + '</div>' +
      '</div>' +
      '<button type="button" class="gg-card-toggle" aria-label="minimise">' + (ggCollapsed[handle] ? 'show shades ▾' : 'hide ▴') + '</button>' +
      '<button class="gg-line-x" data-gg-remove-all aria-label="remove all">✕</button>';
    top.querySelector('[data-gg-remove-all]').addEventListener('click', function () {
      removeLines(items.map(function (it) { return it.key; }));
    });
    card.appendChild(top);
    var list = document.createElement('div');
    list.className = 'gg-shade-list';
    cfg.variants.forEach(function (v) {
      var line = byVariant[v.id];
      var count = line ? line.quantity : 0;
      var row = document.createElement('div');
      row.className = 'gg-shade-row';
      var icon = document.createElement('span');
      icon.className = 's-icon';
      if (v.chip) icon.style.backgroundImage = "url('" + v.chip + "')";
      var name = document.createElement('span');
      name.className = 's-name' + (count > 0 ? ' has' : '');
      name.textContent = v.title;
      peekable(name, cfg, v);
      row.appendChild(icon);
      row.appendChild(name);
      if (count > 0) {
        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'gg-sbtn';
        minus.textContent = '−';
        minus.setAttribute('aria-label', 'remove one ' + v.title);
        minus.addEventListener('click', function () { changeLine(line.key, count - 1); });
        row.appendChild(minus);
        var badge = document.createElement('span');
        badge.className = 's-count';
        badge.textContent = 'x' + count;
        row.appendChild(badge);
      }
      if (isOut(v)) {
        row.classList.add('soldout');
        var outTag = document.createElement('span');
        outTag.className = 's-out';
        outTag.textContent = 'sold out';
        row.appendChild(outTag);
      } else {
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'gg-sbtn plus';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'add ' + v.title);
        plus.addEventListener('click', function () {
          plus.disabled = true;
          addItems([{ id: v.id, quantity: 1 }]);
        });
        row.appendChild(plus);
      }
      list.appendChild(row);
    });
    card.appendChild(list);
    if (window.GG_BN && totalQty >= 4 && ggCollapsed[handle] === undefined) ggCollapsed[handle] = true;
    var tgl = top.querySelector('.gg-card-toggle');
    var applyCollapse = function () {
      var shut = !!ggCollapsed[handle];
      list.style.display = shut ? 'none' : '';
      card.classList.toggle('is-min', shut);
      if (tgl) { tgl.textContent = shut ? 'show shades ▾' : 'hide ▴'; tgl.setAttribute('aria-label', shut ? 'show shades' : 'minimise'); }
    };
    var flip = function (e) { if (e.target.closest('[data-gg-remove-all]')) return; ggCollapsed[handle] = !ggCollapsed[handle]; applyCollapse(); };
    if (tgl) tgl.addEventListener('click', function (e) { e.stopPropagation(); flip(e); });
    top.style.cursor = 'pointer';
    top.addEventListener('click', flip);
    applyCollapse();
    var off = window.GG_BN ? null : GURL_OFFERS[handle];
    if (off) {
      var txt = '';
      if (totalQty < 3) {
        var need = 3 - totalQty;
        txt = 'add ' + need + (need === 1 ? ' more shade' : ' more shades') +
              ' ✦ 3 for ' + GG.money(off.trio) + ', save ' + GG.money(off.one * 3 - off.trio);
      } else if (totalQty <= off.allQty) {
        // Past three the trio price stops applying, so the honest next
        // step is the full set, never another loose shade. The <= matters:
        // every shade bought loose is the dearest basket in the store.
        var nowPays = off.trio + (totalQty - 3) * off.one;
        var more = off.allQty - totalQty;
        txt = off.all <= nowPays
          ? 'the full set costs less ✦ all ' + off.allQty + ' for ' + GG.money(off.all)
          : 'all ' + off.allQty + ' for ' + GG.money(off.all) + ' ✦ ' + more +
            ' more shade' + (more === 1 ? '' : 's') + ' for ' + GG.money(off.all - nowPays);
      }
      if (txt) {
        var nudge = document.createElement('div');
        nudge.className = 'gg-card-nudge';
        nudge.textContent = txt;
        card.appendChild(nudge);
      }
    }
    body.appendChild(card);
  }

  function buildPlainLine(it, byHandle, body) {
    var row = document.createElement('div');
    row.className = 'gg-line-item';

    // The gift is not an ordinary line. No image, because a photo would
    // give away the product she is not supposed to see yet. No stepper
    // and no remove, because the quantity is one and it comes and goes
    // with the $60 threshold, not with her taps: a + here would only be
    // clamped back a moment later, which reads as the site fighting her.
    if (it.variant_id === GIFT_VARIANT) {
      row.className = 'gg-line-item gg-line-gift';
      row.innerHTML =
        '<div class="gg-gift-tile" aria-hidden="true">🎁</div>' +
        '<div class="gg-line-info">' +
        '<div class="gg-line-name">Mystery gift</div>' +
        '<div class="gg-line-shade">one of our products, you’ll loveee it</div>' +
        '<div class="gg-gift-price">' +
        '<s>$15-$22</s><strong>$0</strong><span aria-hidden="true">🎉</span>' +
        '</div></div>';
      body.appendChild(row);
      return;
    }

    row.innerHTML =
      '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '') + '" alt="">' +
      '<div class="gg-line-info">' +
      '<div class="gg-line-name">' + it.product_title.split(' ✦')[0] + '</div>' +
      '<div class="gg-line-shade" data-gg-shade-slot></div>' +
      '<div style="display:flex;align-items:center;gap:10px;margin-top:3px">' +
      '<div class="gg-qty"><button data-gg-dec aria-label="less">−</button><span>' + it.quantity + '</span><button data-gg-inc aria-label="more">+</button></div>' +
      '<div style="font-size:12px;font-weight:600" data-gg-line-price>' + GG.money(it.final_line_price) + '</div>' +
      '</div></div>' +
      '<button class="gg-line-x" data-gg-remove aria-label="remove">✕</button>';
    var shadeSlot = row.querySelector('[data-gg-shade-slot]');
    var p = byHandle[it.handle];
    if (p && p.options && p.options.length > 1 && p.variants && p.variants.length > 1) {
      var cur = p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
      // Keep a retired shade visible only if it is the one already in
      // her bag, so an existing line never silently loses its label.
      p = Object.assign({}, p, {
        variants: p.variants.filter(function (x) {
          return !isRetired(x.title) || x.id === it.variant_id;
        }),
      });
      var shopP = (window.GG_SHOP && window.GG_SHOP.products) || {};
      var srcFor = function (name) {
        var n = String(name).toLowerCase();
        return n.indexOf('mascara') >= 0 ? 'glitter-mascara' : n.indexOf('liner') >= 0 ? 'glitter-eyeliner'
          : n.indexOf('stick') >= 0 ? 'multichrome-eyeshadow-stick' : n.indexOf('gloss') >= 0 ? 'glitter-jelly-lip-gloss'
          : n.indexOf('marker') >= 0 ? 'lip-stain-marker' : 'jelly-glow-eyeshadow';
      };
      var box = document.createElement('div'); box.className = 'gg-bl';
      p.options.forEach(function (opt, oi) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var src = shopP[srcFor(name)];
        var chipOf = function (val) { var v = src && src.variants.filter(function (x) { return x.title === val; })[0]; return v && v.chip; };
        var val = cur ? cur.options[oi] : '';
        var r = document.createElement('div'); r.className = 'gg-bl-row';
        var c0 = chipOf(val);
        r.innerHTML = '<span class="gg-bl-dot"' + (c0 ? ' style="background-image:url(\'' + c0 + '\')"' : '') + '></span>' +
          '<span class="gg-bl-p">' + name.replace(/ shade$/i, '') + '</span>' +
          '<button type="button" class="gg-bl-s">' + val + ' <i>change ▾</i></button>';
        var pick = document.createElement('div'); pick.className = 'gg-bl-pick'; pick.hidden = true;
        var vals = (typeof opt === 'string' ? null : opt.values) || p.variants.map(function (x) { return x.options[oi]; }).filter(function (x, k, a) { return a.indexOf(x) === k; });
        // opt.values is Shopify's full option list and wins over the
        // variants above, so the retired shades have to come out here
        // too. The one she already has stays, or her own line would
        // lose its label.
        vals = vals.filter(function (nv) { return !isRetired(nv) || nv === val; });
        vals.forEach(function (nv) {
          var want = cur.options.slice(); want[oi] = nv;
          var target = p.variants.filter(function (x) { return x.options.join('|') === want.join('|'); })[0];
          var ok = target && target.available;
          var c = document.createElement('button'); c.type = 'button';
          c.className = 'gg-chip' + (nv === val ? ' on' : '') + (ok ? '' : ' is-out');
          var ci = chipOf(nv);
          c.innerHTML = (ci ? '<span class="c-img" style="background-image:url(' + ci + ')"></span>' : '') + '<span>' + nv + '</span>';
          c.addEventListener('click', function () { if (!ok || nv === val) return; swapVariant(it, target.id); });
          pick.appendChild(c);
        });
        r.querySelector('.gg-bl-s').addEventListener('click', function () { pick.hidden = !pick.hidden; });
        box.appendChild(r); box.appendChild(pick);
      });
      shadeSlot.appendChild(box);
    } else if (p && p.variants && p.variants.length > 1) {
      var sel = document.createElement('select');
      sel.className = 'gg-line-select';
      sel.setAttribute('aria-label', 'change shade');
      p.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id; o.textContent = v.title;
        if (v.id === it.variant_id) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () { swapVariant(it, parseInt(sel.value, 10)); });
      shadeSlot.appendChild(sel);
    } else if (it.variant_title && it.variant_title !== 'Default Title') {
      shadeSlot.textContent = it.variant_title;
    }
    var pv = p && (p.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
    if (pv && pv.compare_at_price > pv.price) {
      row.querySelector('[data-gg-line-price]').innerHTML = '<s class="gg-line-was">' + GG.money(pv.compare_at_price * it.quantity) + '</s> ' + GG.money(it.final_line_price);
    }
    row.querySelector('[data-gg-dec]').addEventListener('click', function () { changeLine(it.key, it.quantity - 1); });
    row.querySelector('[data-gg-inc]').addEventListener('click', function () { changeLine(it.key, it.quantity + 1); });
    row.querySelector('[data-gg-remove]').addEventListener('click', function () { changeLine(it.key, 0); });
    body.appendChild(row);
  }

  function buildUpsell(c, upsellEl, shop) {
    if (!upsellEl) return;
    upsellEl.innerHTML = '';
    var inCart = {};
    c.items.forEach(function (it) { inCart[it.handle] = 1; });
    var missing = CORE_HANDLES.filter(function (h) { return !inCart[h] && shop[h]; }).slice(0, 2);
    if (!missing.length) return;
    var label = document.createElement('div');
    label.className = 'gg-upsell-label';
    label.textContent = 'complete the look ✦ tap a shade to add';
    upsellEl.appendChild(label);
    missing.forEach(function (h) {
      var p = shop[h];
      var row = document.createElement('div');
      row.className = 'gg-upsell-row';
      row.innerHTML =
        (p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '') +
        '<div class="gg-upsell-info"><div>' + p.title + '</div><div class="p">' + GG.money(p.price) + '</div></div>';
      var chips = document.createElement('div');
      chips.className = 'gg-mini-chips';
      p.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        var vOut = isOut(v);
        b.className = 'gg-mini-chip' + (vOut ? ' soldout' : '');
        b.title = vOut ? v.title + ' ✦ sold out' : v.title + ' ✦ add';
        b.setAttribute('aria-label', vOut ? p.title + ' in ' + v.title + ' is sold out' : 'add ' + p.title + ' in ' + v.title);
        if (v.chip) b.style.backgroundImage = "url('" + v.chip + "')";
        if (vOut) {
          b.disabled = true;
        } else {
          b.addEventListener('click', function () {
            b.style.opacity = '.4';
            addItems([{ id: v.id, quantity: 1 }]);
          });
        }
        chips.appendChild(b);
      });
      row.appendChild(chips);
      upsellEl.appendChild(row);
    });
  }

  function buildFoot(c, foot) {
    if (!foot) return;
    foot.hidden = false;
    var subEl = document.getElementById('gg-sum-subtotal');
    var discountRow = document.getElementById('gg-discount-row');
    var discEl = document.getElementById('gg-sum-discount');
    document.getElementById('gg-sum-total').textContent = GG.money(c.total_price);
    subEl.textContent = GG.money(c.original_total_price);
    if (discountRow) discountRow.hidden = true;
    // Gurl math = everything she saves: the crossed-out price on sale items
    // and collections (compare at vs price) plus any discount codes.
    var names = [], seen = {};
    var addName = function (t) {
      if (!t) return;
      t = String(t).toLowerCase().replace(/^gurl math ✦ /, '').replace(/^gg · /, '');
      if (!seen[t]) { seen[t] = 1; names.push(t); }
    };
    (c.cart_level_discount_applications || []).forEach(function (a) { addName(a.title); });
    (c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) { addName(a.discount_application && a.discount_application.title); });
      (it.discounts || []).forEach(function (dd) { addName(dd.title); });
    });
    // The free product over $60. It has to be a real line and not a cart
    // attribute, because Shopify only shows line items at checkout, and
    // only a line can be counted, packed and taken out of stock. The line
    // is a $0 placeholder that names the promise but not the product;
    // which product it actually is gets decided in Command Center when
    // the order lands, so the packer knows and the customer does not.
    var GIFT_MIN = 6000;
    var giftLine = null;
    (c.items || []).forEach(function (it) {
      if (it.variant_id === GIFT_VARIANT) giftLine = it;
    });
    // total_price is what she actually pays, after any discount code, so
    // the threshold is measured on the money rather than on the ticket.
    // The gift itself is $0, so adding it cannot push her back over.
    var wantGift = bnPaid(c) >= GIFT_MIN;
    if (!window.__ggGiftBusy) {
      var done = function () { window.__ggGiftBusy = false; };
      if (wantGift && !giftLine) {
        window.__ggGiftBusy = true;
        addItemsRaw([{ id: GIFT_VARIANT, quantity: 1 }])
          .then(function () { done(); return fetchCart(); }, done);
      } else if (!wantGift && giftLine) {
        window.__ggGiftBusy = true;
        changeLine(giftLine.key, 0).then(done, done);
      } else if (giftLine && giftLine.quantity > 1) {
        // One gift per order however she got there.
        window.__ggGiftBusy = true;
        changeLine(giftLine.key, 1).then(done, done);
      }
    }
    var stamp = c.token + ':' + c.total_price + ':' + c.item_count;
    foot.setAttribute('data-gg-stamp', stamp);
    var singles = (window.GG_SHOP && window.GG_SHOP.products) || {};
    Promise.all((c.items || []).map(function (it) {
      // Single shades count at their selling price; only bundles and
      // collections carry a gurl math saving.
      if (singles[it.handle]) return Promise.resolve(0);
      return getProduct(it.handle).then(function (p) {
        var v = p && (p.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
        return v && v.compare_at_price > v.price ? (v.compare_at_price - v.price) * it.quantity : 0;
      }).catch(function () { return 0; });
    })).then(function (arr) {
      if (foot.getAttribute('data-gg-stamp') !== stamp) return;
      var sale = arr.reduce(function (a, x) { return a + x; }, 0);
      var codeAmt = 0;
      (c.cart_level_discount_applications || []).forEach(function (a) { if (a.type === 'discount_code') codeAmt += a.total_allocated_amount || 0; });
      (c.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application && a.discount_application.type === 'discount_code') codeAmt += a.amount || 0; }); });
      var codeRow = document.getElementById('gg-code-row');
      if (!codeRow && discountRow) {
        codeRow = discountRow.cloneNode(true); codeRow.id = 'gg-code-row';
        discountRow.parentNode.insertBefore(codeRow, discountRow.nextSibling);
      }
      if (codeRow) {
        codeRow.hidden = codeAmt <= 0;
        var cl = codeRow.querySelector('span'), cv = codeRow.querySelector('b');
        if (cv) cv.removeAttribute('id');
        if (cl) cl.textContent = 'code ✦ ' + (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code.toLowerCase(); }).join(' + ');
        if (cv) cv.textContent = '−' + GG.money(codeAmt);
      }
      var codeNames = (c.discount_codes || []).map(function (d) { return d.code.toLowerCase(); });
      names = names.filter(function (n) { return codeNames.indexOf(n) < 0; });
      var saved = sale + (c.total_discount || 0) - codeAmt;
      // ggBN: on the unpublished draft the discount is not switched on yet, so the bag shows what the
      // checkout function will take off. Once published it only ever shows the real discount.
      var bnR = window.GG_BN && window.GG_BN_CART_CALC ? window.GG_BN_CART_CALC(c) : null;
      var bnLive = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main');
      if (bnR && !bnLive) {
        // preview: ignore the old live discounts, show exactly what Black November will do
        saved = bnR.save;
        subEl.textContent = GG.money(c.original_total_price);
        document.getElementById('gg-sum-total').textContent = GG.money(c.original_total_price - bnR.save);
      }
      var bnBox = document.getElementById('gg-bn-saved');
      if (!bnBox && window.GG_BN) {
        var totRow = document.querySelector('#gg-drawer-foot .gg-total-row');
        if (totRow) { bnBox = document.createElement('div'); bnBox.id = 'gg-bn-saved'; bnBox.className = 'gg-bn-saved'; totRow.parentNode.insertBefore(bnBox, totRow.nextSibling); }
      }
      if (bnBox) { bnBox.hidden = !(saved > 0); bnBox.innerHTML = '🎉 you\'re saving <b>' + GG.money(saved) + '</b> this black november'; }
      subEl.textContent = GG.money(c.original_total_price + sale);
      if (!discountRow) return;
      discountRow.hidden = saved <= 0;
      if (saved > 0) {
        discEl.textContent = '−' + GG.money(saved);
        var label = discountRow.querySelector('span');
        if (label) label.textContent = window.GG_BN ? 'black november ✦ ' + (bnR && bnR.free ? bnR.free + ' free item' + (bnR.free > 1 ? 's' : '') : 'free items') + ' 🎁' : (names.length ? 'gurl math ✦ ' + names.join(' + ') : 'gurl math ✦ bundle saving');
      }
    });
  }

  function openDrawer() {
    if (window.GG_BN && window.GG_BN_BAG) { window.GG_BN_BAG(); return; }
    document.getElementById('gg-drawer').classList.add('open');
    document.getElementById('gg-overlay').classList.add('open');
  }
  function closeDrawer() {
    document.getElementById('gg-drawer').classList.remove('open');
    document.getElementById('gg-overlay').classList.remove('open');
  }
  window.addEventListener('gg-open-cart', openDrawer);

  /* ── header ───────────────────────────────────── */
  function initHeader() {
    var bagBtn = document.getElementById('gg-bag-btn');
    if (bagBtn) bagBtn.addEventListener('click', openDrawer);
    var closeBtn = document.getElementById('gg-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    var overlay = document.getElementById('gg-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);
    var burger = document.getElementById('gg-burger');
    var mnav = document.getElementById('gg-nav-mobile');
    if (burger && mnav) burger.addEventListener('click', function () {
      mnav.classList.toggle('open');
      burger.textContent = mnav.classList.contains('open') ? '✕' : '☰';
    });
    updateMeters();
  }

  /**
   * Writes the meter sentence, sliding it when it does not fit.
   *
   * On a phone the bar is one line and this sentence is longer than it,
   * so the stock behaviour clipped it to "(wor…" and threw away the part
   * that actually sells. When it overflows the sentence is laid down
   * twice and the track is shifted by exactly half its width, which puts
   * copy two where copy one started and makes the loop seamless.
   *
   * Short sentences are left alone: motion for its own sake is noise.
   */
  function setMeterText(el, text) {
    if (el.getAttribute('data-gg-text') === text) return;
    el.setAttribute('data-gg-text', text);
    el.classList.remove('is-scroll');
    el.textContent = text;
    requestAnimationFrame(function () {
      if (el.scrollWidth <= el.clientWidth + 1) return;
      var unit = text + '  ✦  ';
      var track = document.createElement('span');
      track.className = 'gg-mt-track';
      [unit, unit].forEach(function (u) {
        var c = document.createElement('span');
        c.textContent = u;
        track.appendChild(c);
      });
      el.textContent = '';
      el.appendChild(track);
      el.classList.add('is-scroll');
      // Pace it by length, so a long sentence and a short one read at the
      // same speed rather than taking the same time.
      track.style.animationDuration = Math.max(14, Math.round(unit.length * 0.42)) + 's';
    });
  }

  var FREE_SHIP_CENTS = 5000;
  var GIFT_CENTS = 6000;
  function updateMeters() {
    // One bar from $0 to the gift threshold, with a milestone dot at free delivery.
    var total = cartState ? bnPaid(cartState) : 0;
    var ship = total >= FREE_SHIP_CENTS, gift = total >= GIFT_CENTS;
    var text = gift ? 'free delivery + your free gift unlocked 💋 (worth $15-22)'
      : ship ? 'free delivery unlocked 💋 ✦ ' + GG.money(GIFT_CENTS - total) + ' to a free gift worth $15-22'
      : 'free delivery ✦ ' + GG.money(FREE_SHIP_CENTS - total) + ' away';
    var pct = Math.max(4, Math.min(100, total * 100 / GIFT_CENTS));
    ['announce', 'cart'].forEach(function (where) {
      var t = document.getElementById('gg-' + where + '-one-text');
      var f = document.getElementById('gg-' + where + '-one-fill');
      var ms = document.getElementById('gg-' + where + '-ms-ship');
      var mg = document.getElementById('gg-' + where + '-ms-gift');
      if (t) { setMeterText(t, text); t.classList.toggle('is-done', ship); }
      if (f) f.style.width = pct + '%';
      if (ms) ms.classList.toggle('done', ship);
      if (mg) mg.classList.toggle('done', gift);
      // When the kiss reaches a checkpoint it becomes that checkpoint's
      // emoji and the marker steps aside, so the two never stack.
      var SHIP_PCT = FREE_SHIP_CENTS * 100 / GIFT_CENTS;
      var atGift = pct >= 93, atShip = !atGift && Math.abs(pct - SHIP_PCT) < 7.5;
      var kiss = f && f.querySelector('.gg-meter-kiss');
      if (kiss) kiss.textContent = atGift ? '🎁' : atShip ? '🚚' : '💋';
      if (ms) ms.classList.toggle('is-under', atShip);
      if (mg) mg.classList.toggle('is-under', atGift);
    });
  }
  window.__ggAnnounceRefresh = updateMeters;

  /* ── accordions ───────────────────────────────── */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('.gg-acc > button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.parentElement;
        var open = acc.classList.contains('open');
        acc.parentElement.querySelectorAll('.gg-acc').forEach(function (a) { a.classList.remove('open'); a.querySelector('button span:last-child').textContent = '+'; });
        if (!open) { acc.classList.add('open'); btn.querySelector('span:last-child').textContent = '−'; }
      });
    });
  }

  /* ── PDP ──────────────────────────────────────── */
  function initPdp() {
    var dataEl = document.getElementById('gg-product-data');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    data.variants = (data.variants || []).filter(function (v) { return v.shade !== 'red flag'; });
    data.media = (data.media || []).filter(function (m) { return (m.alt || '').indexOf('~') < 0; });
    // ggBN: Black November replaces gurl math. Pay for 2 get 2, pay for 3 get 3.
    if (window.GG_BN && data.type !== 'dual' && data.tierPrices && data.tierPrices.length >= 3) {
      var bnP = data.priceCents;
      data.tierPrices = [bnP, bnP * 2, bnP * 3];
      data.tierSaves = [0, Math.round(bnP * 2 / 100), Math.round(bnP * 3 / 100)];
      data.tierQtys = [1, 4, 6];
      data.collection = null;
    }
    // ggSolidShades: the marker is a matte stain, so its shade dots are flat
    // colours sampled from the on-lips photos (2026-11-02), not glitter swatches.
    var GG_SHADE_HEX = ({
      'lip-stain-marker': { 'habibi': '#A46168', 'soft launch': '#BB677D', 'main character': '#C0262E', 'after midnight': '#8E1F33', 'first date': '#D2859D' }
    })[data.handle];
    // ggGlossSwatches: the gloss uses its own close-up glitter swatch photos (theme assets).
    var GG_SW = (window.GG_SWATCHES || {})[data.handle];
    if (GG_SW) data.variants.forEach(function (v) { if (GG_SW[v.shade]) v.chip = GG_SW[v.shade]; });
    if (GG_SHADE_HEX) data.variants.forEach(function (v) {
      var hx = GG_SHADE_HEX[v.shade];
      if (hx) v.chip = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"><rect width="1" height="1" fill="' + hx + '"/></svg>');
    });
    function firstInStock(list, inStock) {
      for (var i = 0; i < list.length; i++) { if (inStock(i)) return i; }
      return 0;
    }
    var startShade = 0, startSel1 = 0, startSel2 = 0;
    if (data.type === 'dual') {
      var a1 = (data.options && data.options.avail1) || [];
      var a2 = (data.options && data.options.avail2) || [];
      startSel1 = firstInStock(data.options.values1, function (i) { return a1[i] !== false; });
      startSel2 = firstInStock(data.options.values2, function (i) { return a2[i] !== false; });
    } else {
      startShade = firstInStock(data.variants, function (i) { return !isOut(data.variants[i]); });
    }
    // ggBN: bundle slots open pre-filled with in-stock shades, she only changes what she wants.
    function bnPrefill(n) {
      var ok = [];
      data.variants.forEach(function (v, i) { if (!isOut(v)) ok.push(i); });
      if (!ok.length) ok = [0];
      var start = Math.max(0, ok.indexOf(startShade)), a = [];
      for (var i = 0; i < n; i++) a.push(ok[(start + i) % ok.length]);
      return a;
    }
    var state = { shade: startShade, img: 0, tier: 0, slots: [], sel1: startSel1, sel2: startSel2 };
    if (data.type !== 'dual' && data.tierPrices && data.tierPrices.length >= 3) {
      state.tier = 1;
      // However many shades this product's trio is, not always two.
      var tq0 = data.tierQtys || TIER_QTY;
      for (var s0 = 0; s0 < tq0[1]; s0++) state.slots.push(null);
      if (window.GG_BN) { state.tier = 1; state.slots = [null, null, null, null]; state.bnPick = null; }   // buy 2, get 2, she picks (Ali)
      if (window.GG_BOX) { state.tier = 0; state.slots = []; }   // v2: pick a shade, add it, the bag does the maths
    }
    var mainEl = document.getElementById('gg-gallery-main');
    var thumbsEl = document.getElementById('gg-thumbs');
    var chipsEl = document.getElementById('gg-chips');
    var chips2El = document.getElementById('gg-chips-2');
    var shadeNameEl = document.getElementById('gg-shade-name');
    var shadeName2El = document.getElementById('gg-shade-name-2');
    var hintEl = document.getElementById('gg-pick-hint');
    var tiersEl = document.getElementById('gg-tiers');
    var slotsEl = document.getElementById('gg-slots');
    var ctas = Array.prototype.slice.call(document.querySelectorAll('[data-gg-cta]'));
    var priceEls = Array.prototype.slice.call(document.querySelectorAll('[data-gg-tier-price]'));

    function galleryFor(shadeName) {
      var hero = data.media.filter(function (m) { return m.alt === shadeName; });
      var rest = data.media.filter(function (m) { return m.alt !== shadeName && m.alt.indexOf(shadeName + ' ') === 0; });
      var shared = data.media.filter(function (m) { return m.alt.indexOf('✦') >= 0 && !/#\d+\s*$/.test(m.alt); });
      // shared media can ask for a spot in every shade's gallery: alt "name ✦ #3" = third position
      var placed = data.media.filter(function (m) { return m.alt.indexOf('✦') >= 0 && /#\d+\s*$/.test(m.alt); });
      var lead = hero;
      if (data.appliedSuffix) {
        var want = shadeName + data.appliedSuffix;
        var applied = rest.filter(function (m) { return m.alt === want; });
        if (applied.length) {
          lead = applied.concat(hero);
          rest = rest.filter(function (m) { return m.alt !== want; });
        }
      }
      var out = lead.concat(rest, shared);
    // ggFaceFirst: open each shade on its worn shot (lips or eyes), except
    // the eyeshadows whose first image is already the eye.
    if (['jelly-glow-eyeshadow', 'multichrome-eyeshadow-stick'].indexOf(data.handle) < 0) {
      var ggWant = [' on lips', ' lips', ' look'];
      for (var gw = 0; gw < ggWant.length; gw++) {
        var gk = out.findIndex(function (x) { return x.alt === shadeName + ggWant[gw]; });
        if (gk > 0) { out = [out[gk]].concat(out.slice(0, gk), out.slice(gk + 1)); break; }
      }
    }
    // ggVideoSecond: on the marker, each shade's video sits right after the worn shot
    if (data.handle === 'lip-stain-marker') {
      var vk = out.findIndex(function (x) { return x.alt === shadeName + ' video'; });
      if (vk > 1) { var vv = out.splice(vk, 1)[0]; out.splice(1, 0, vv); }
    }
      placed.forEach(function (m) {
        var at = parseInt(m.alt.match(/#(\d+)\s*$/)[1], 10) - 1;
        out.splice(Math.max(0, Math.min(at, out.length)), 0, m);
      });
      return out.length ? out : data.media;
    }
    function bg(el, src) { el.style.backgroundImage = "url('" + src + "')"; }
    function defaultSlots(n) { var a = []; for (var i = 0; i < n; i++) a.push(i % data.variants.length); return a; }
    function shadeCarousel(shadeName) {
      var imgs = data.media.filter(function (m) { return m.alt === shadeName || m.alt.indexOf(shadeName + ' ') === 0; });
      if (!imgs.length) imgs = galleryFor(shadeName).slice(0, 5);
      var car = document.createElement('div');
      car.className = 'gg-shade-carousel';
      imgs.forEach(function (m) {
        var cell = document.createElement('div');
        cell.className = 'gg-carousel-cell';
        cell.style.backgroundImage = "url('" + m.src + "')";
        if (/sticker/i.test(m.alt)) cell.insertAdjacentHTML('beforeend', '<span class="gg-cell-gift">🎁 free sticker pack</span>');
        car.appendChild(cell);
      });
      return car;
    }

    function render() {
      var gallery, ctaLabel, ctaShort, ready = true, priceCents, shade = null, soldOut = false;
      if (data.type === 'dual') {
        var v1 = data.options.values1[state.sel1];
        var v2 = data.options.values2[state.sel2];
        var g1 = (data.options.gal1 || [])[state.sel1] || {};
        var g2 = (data.options.gal2 || [])[state.sel2] || {};
        var mk = [{ src: g1.applied, alt: v1 + ' lips' }, { src: g1.hero, alt: v1 }];
        var gl = [{ src: g2.applied, alt: v2 + ' on lips' }, { src: g2.hero, alt: v2 }];
        var pairs = state.lastSel === 'sel2' ? [gl[0], mk[0], gl[1], mk[1]] : [mk[0], gl[0], mk[1], gl[1]];
        var shadeImgs = pairs.filter(function (p) { return p.src; });
        gallery = shadeImgs.concat(data.media);
        var key = data.options.values1[state.sel1] + '|' + data.options.values2[state.sel2];
        var v = data.variantMap[key];
        priceCents = data.priceCents;
        ctaLabel = 'Get the Combo ✦ ' + GG.money(priceCents);
        ctaShort = ctaLabel;
        state.resolved = v;
        soldOut = (data.options.avail1 || [])[state.sel1] === false ||
                  (data.options.avail2 || [])[state.sel2] === false || !v;
        if (shadeNameEl) shadeNameEl.textContent = data.options.values1[state.sel1];
        if (shadeName2El) shadeName2El.textContent = data.options.values2[state.sel2];
        renderDualChips();
      } else {
        shade = state.shade >= 0 ? data.variants[state.shade] : null;
        gallery = shade ? galleryFor(shade.shade) : data.media;
        var multi = state.tier > 0;
        ready = !multi || state.slots.every(function (s) { return s !== null; });
        soldOut = !multi && isOut(shade);
        var TQL = data.tierQtys || TIER_QTY;
        var allLbl = (data.collection && data.collection.label)
          ? data.collection.label : 'all ' + TQL[2] + ' shades';
        var bnNn = BN_NOUN[data.handle] || ['shade', 'shades'];
        var tierNames = window.GG_BN ? ['just one', Math.max(4, state.slots.length) + ' ' + bnNn[1], '6 ' + bnNn[1]] : ['just one', TQL[1] + ' shades', allLbl];
        priceCents = (state.tier === 2 && data.collection)
          ? data.collection.price : data.tierPrices[state.tier];
        if (window.GG_BN && state.tier === 1) priceCents = data.tierPrices[0] * Math.max(4, state.slots.length) / 2;
        ctaLabel = multi ? 'Add ' + tierNames[state.tier] + ' ✦ ' + GG.money(priceCents) : 'Add to Bag ✦ ' + GG.money(priceCents);
        ctaShort = multi ? 'Add ' + tierNames[state.tier] : 'Add to Bag';
        if (window.GG_BOX && !multi) { ctaLabel = 'add ' + (shade ? shade.shade : 'it') + ' to my bag ✦ ' + GG.money(priceCents); ctaShort = 'add to my bag'; }
        if (window.GG_BN && state.tier === 1 && bnCartCount() > 0) {
          ready = true;
          ctaLabel = 'check out ✦ ' + bnCartCount() + ' in your bag →';
          ctaShort = 'check out →';
        }
        if (shadeNameEl) shadeNameEl.textContent = shade ? shade.shade : 'pick your shade ✦';
        renderTiers();
        renderChips();
        renderSlots();
      }
      state.img = Math.min(state.img, gallery.length - 1);
      var current = gallery[state.img] || gallery[0];
      if (mainEl && current) {
        bg(mainEl, current.src);
        var ggV = mainEl.querySelector('video');
        if (current.video) {
          if (!ggV || ggV.getAttribute('src') !== current.video) {
            if (ggV) ggV.remove();
            ggV = document.createElement('video');
            ggV.setAttribute('src', current.video);
            ggV.muted = true; ggV.loop = true; ggV.autoplay = true; ggV.playsInline = true;
            ggV.setAttribute('muted', ''); ggV.setAttribute('playsinline', ''); ggV.setAttribute('autoplay', ''); ggV.setAttribute('loop', '');
            ggV.setAttribute('poster', current.src);
            ggV.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;border-radius:inherit;z-index:1';
            mainEl.appendChild(ggV);
            var ggP = ggV.play && ggV.play(); if (ggP && ggP.catch) ggP.catch(function () {});
          }
        } else if (ggV) { ggV.remove(); }
        var isHero = data.type === 'dual'
          ? (current.alt === data.options.values1[state.sel1] || current.alt === data.options.values2[state.sel2])
          : !!(shade && current.alt === shade.shade);
        mainEl.style.backgroundSize = isHero ? 'contain' : 'cover';
        mainEl.setAttribute('aria-label', current.alt);
        // The sticker sheet slide says out loud that it is a gift.
        var gift = /sticker/i.test(current.alt);
        mainEl.classList.toggle('gg-is-gift', gift);
        if (gift) mainEl.style.overflow = 'visible'; else if (!current.video) mainEl.style.overflow = '';
        var gt = mainEl.querySelector('.gg-gift-tag');
        if (gift && !gt) { gt = document.createElement('span'); gt.className = 'gg-gift-tag'; gt.textContent = '🎁 free sticker pack with every order'; mainEl.appendChild(gt); }
        if (!gift && gt) gt.remove();
      }
      if (thumbsEl) {
        thumbsEl.innerHTML = '';
        gallery.forEach(function (m, i) {
          var b = document.createElement('button');
          if (i === state.img) b.className = 'on';
          var d = document.createElement('div');
          d.className = 'gg-thumb-img';
          bg(d, m.src);
          if (m.video) { d.style.position = 'relative'; d.innerHTML = '<span style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:22px;height:22px;border-radius:50%;background:rgba(23,18,18,.6);color:#fff;font-size:10px;line-height:22px;text-align:center;padding-left:2px">&#9654;</span>'; }
          if (/sticker/i.test(m.alt)) { b.style.position = 'relative'; b.insertAdjacentHTML('beforeend', '<span class="gg-thumb-gift">🎁 free</span>'); }
          b.appendChild(d);
          b.addEventListener('click', function () { state.img = i; render(); });
          thumbsEl.appendChild(b);
        });
        ggThumbRow(thumbsEl);
      }
      state.soldOut = soldOut;
      ctas.forEach(function (btn) {
        var isSticky = btn.hasAttribute('data-gg-cta-short');
        if (soldOut) {
          btn.disabled = true;
          btn.textContent = isSticky ? 'sold out' : 'sold out ✦ pick another shade';
        } else if ((isSticky || window.GG_BN) && !ready) {
          btn.disabled = false;
          btn.textContent = 'pick your shades ✦';
        } else {
          btn.disabled = !ready;
          btn.textContent = isSticky ? ctaShort : ctaLabel;
        }
      });
      priceEls.forEach(function (el) { el.textContent = GG.money(priceCents); });
      var stName = document.getElementById('gg-sticky-name'), stSub = document.getElementById('gg-sticky-sub');
      if (stName && stSub && data.type !== 'dual' && data.tierPrices && data.tierPrices.length >= 3) {
        var stT = data.tierQtys || TIER_QTY;
        var stAll = (data.collection && data.collection.label) ? data.collection.label : 'all ' + stT[2] + ' shades';
        var bnN = window.GG_BN ? bnCartCount() : 0;
        var bnP = Math.min(10, bnN < 4 ? 4 : bnN + (bnN % 2 ? 1 : 2)) / 2;   // same pair the card shows
        stName.textContent = capFirst((window.GG_BN ? ['just one', 'buy ' + bnP + ', get ' + bnP + ' free', 'buy 3, get 3 free'] : ['just one', 'any ' + stT[1] + ' shades', stAll])[state.tier]);
        stSub.textContent = GG.money(priceCents) + (priceCents >= 5000 ? ' · free delivery' : ' · cash on delivery');
      }
    }

    function capFirst(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
    // ggCards: the bundle picker as stacked radio cards. The chosen card opens
    // to hold its shade slots and what she wins, so picking a bundle and
    // filling it happen in one place.
    // ggBN cards (v9): "just one" and the growing bundle. The bundle starts EMPTY as 2 + 2 free; she taps
    // shade circles to fill it. When she adds the 5th it becomes buy 3, get 3 (6 slots) and so on up to
    // buy 5, get 5. Removing shrinks it back. Shade circles only (no photos), ✕ to remove (Ali 2026-11-03).
    function bnPicks() { return state.slots.filter(function (s) { return s !== null && s !== undefined; }); }
    function bnSetPicks(picks) {
      var n = Math.min(10, Math.max(4, picks.length + (picks.length % 2)));
      state.slots = picks.slice(0, 10);
      while (state.slots.length < n) state.slots.push(null);
    }
    // The picker mirrors her bag (Ali 2026-11-03): shades of this product already in the bag show as picked,
    // new taps are "pending", and only pending ones get added. ✕ on a bag item takes it out of the bag.
    function bnBase() {
      var counts = {}, list = [];
      ((cartState && cartState.items) || []).forEach(function (it) {
        if (!(it.price > 0)) return;
        for (var vi = 0; vi < data.variants.length; vi++) {
          if (data.variants[vi].id === it.variant_id) {
            counts[vi] = (counts[vi] || 0) + it.quantity;
            for (var q = 0; q < it.quantity; q++) list.push(vi);
          }
        }
      });
      return { counts: counts, list: list };
    }
    function bnPending() {
      var b = bnBase().counts, c = {}, out = { _total: 0 };
      bnPicks().forEach(function (vi) { c[vi] = (c[vi] || 0) + 1; });
      Object.keys(c).forEach(function (vi) { var d = c[vi] - (b[vi] || 0); if (d > 0) { out[vi] = d; out._total += d; } });
      return out;
    }
    function bnRebuild(pend) {
      var list = bnBase().list.slice();
      Object.keys(pend).forEach(function (vi) { if (vi !== '_total') for (var q = 0; q < pend[vi]; q++) list.push(+vi); });
      bnSetPicks(list);
    }
    function bnSyncFromCart() { if (state.tier === 1) bnRebuild({ _total: 0 }); }
    function bnCartCount() { return ((cartState && cartState.items) || []).reduce(function (s, it) { return s + (it.price > 0 ? it.quantity : 0); }, 0); }
    function bnRemoveOne(vi) {
      var pend = bnPending();
      if (pend[vi]) { pend[vi]--; pend._total--; bnRebuild(pend); render(); return; }
      var line = ((cartState && cartState.items) || []).filter(function (it) { return it.variant_id === data.variants[vi].id && it.price > 0; })[0];
      if (!line) return;
      changeLine(line.key, line.quantity - 1).then(function () { bnRebuild(pend); render(); });
    }
    function bnPendingItems() {
      var pd = bnPending(), items = [];
      Object.keys(pd).forEach(function (vi) { if (vi !== '_total') items.push({ id: data.variants[vi].id, quantity: pd[vi] }); });
      return items;
    }
    function renderTiersBN() {
      var nn = BN_NOUN[data.handle] || ['shade', 'shades'];
      var unit = data.tierPrices[0];
      var build = window.GG_BN_BUILD || '/pages/build-your-bag';
      tiersEl.classList.add('gg-tcards', 'gg-bn-cards');
      if (slotsEl && slotsEl.parentNode) slotsEl.parentNode.removeChild(slotsEl);
      tiersEl.innerHTML = '';
      [0, 1].forEach(function (t) {
        var on = t === state.tier;
        // heading follows her whole bag: 2+2 until she has 4, then the next pair (buy 3 get 3 at 4 items, Ali 2026-11-03)
        var bagCount = 0;
        ((cartState && cartState.items) || []).forEach(function (it) { if (it.price > 0) bagCount += it.quantity; });
        var tgt = Math.min(10, bagCount < 4 ? 4 : bagCount + (bagCount % 2 ? 1 : 2));
        var qty = t ? (on ? tgt : 4) : 1;
        var paid = t ? qty / 2 : 1, free = qty - paid;
        var price = unit * paid, worth = unit * qty;
        var card = document.createElement('div');
        card.className = 'gg-tcard' + (on ? ' on' : '') + (t ? ' tc-bn' : '');
        if (t) card.insertAdjacentHTML('beforeend', '<div class="tc-bn-band">🎁 black november exclusive 🎁</div><span class="tc-tag tc-tag-raspberry">most popular</span>');
        var head = document.createElement('button');
        head.type = 'button';
        head.className = 'gg-tier tc-head';
        head.setAttribute('aria-pressed', on ? 'true' : 'false');
        head.innerHTML = '<span class="tc-radio" aria-hidden="true"></span>' +
          '<span class="tc-main"><span class="tc-top"><span class="tc-name">' + (t ? 'Buy ' + paid + ', get ' + paid + ' free' : 'Just one') + '</span></span>' +
          (t ? '<span class="tc-eachst">only ' + GG.money(Math.round(price / qty)) + ' each</span>' : '<span class="tc-sub">one ' + nn[0] + ', your pick</span>') + '</span>' +
          '<span class="tc-right"><span class="tc-price">' + GG.money(price) + '</span>' +
          (t ? '<s class="tc-worth">' + GG.money(worth) + '</s><span class="tc-savest">save ' + GG.money(unit * free) + '</span>' : '') + '</span>';
        head.addEventListener('click', function () {
          if (state.tier === t) return;
          state.tier = t;
          state.slots = [];
          if (t) bnSyncFromCart();   // her bag, not a blank picker
          if (state.shade < 0) state.shade = 0;
          render();
        });
        card.appendChild(head);
        var strip = null;
        if (t) {
          // the dotted slots: paid on the left, free on the right
          strip = document.createElement('div');
          strip.className = 'tc-strip tc-strip2';
          strip.innerHTML = '<div class="tc-row-l">you pay</div><div class="tc-row tc-row-paid"></div><div class="tc-row-l free">free 🎁</div><div class="tc-row tc-row-free"></div>';
          var rowPaid = strip.querySelector('.tc-row-paid'), rowFree = strip.querySelector('.tc-row-free');
          var mkCell = function (vi, isFree, placeholder) {
            var pv = vi === null ? null : data.variants[vi];
            var cell = document.createElement('button');
            cell.type = 'button';
            cell.className = 'tc-th' + (isFree ? ' free' : '') + (pv ? ' filled' : ' empty') + (placeholder ? ' next' : '');
            cell.innerHTML = (pv ? '<span style="background-image:url(\'' + (pv.chip || '') + '\')"></span><b>✕</b>' : '<span></span>') +
              (isFree ? '<em>' + (placeholder ? 'next free' : 'free') + '</em>' : (placeholder ? '<em class="nx">next</em>' : ''));
            if (pv) cell.setAttribute('aria-label', 'remove ' + pv.shade);
            cell.addEventListener('click', function (e) {
              e.stopPropagation();
              if (!on) { head.click(); return; }
              if (pv) bnRemoveOne(vi);
              else { var cb = card.querySelector('.tc-chips'); if (cb) cb.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
            });
            (isFree ? rowFree : rowPaid).appendChild(cell);
          };
          if (!on) {
            // not selected yet: just show the offer, 2 + 2 free
            for (var i = 0; i < qty; i++) mkCell(null, i >= paid, false);
          } else {
            // selected: her units of THIS product, marked free exactly as checkout will across her WHOLE bag,
            // plus one dashed "next" slot that sits in the free row only when her next item really is free
            var bagUnits = [];
            ((cartState && cartState.items) || []).forEach(function (it) {
              if (!(it.price > 0)) return;
              for (var q = 0; q < it.quantity; q++) bagUnits.push({ vid: it.variant_id, price: it.price });
            });
            var bagN = bagUnits.length, bagFree = bagN >= 3 ? Math.min(Math.floor(bagN / 2), 5) : 0;
            bagUnits.map(function (u, ix) { return { i: ix, p: u.price }; }).sort(function (a2, b2) { return a2.p - b2.p || a2.i - b2.i; })
              .slice(0, bagFree).forEach(function (x) { bagUnits[x.i].free = true; });
            var mineFree = 0;
            bagUnits.forEach(function (u) {
              for (var vi = 0; vi < data.variants.length; vi++) if (data.variants[vi].id === u.vid) { mkCell(vi, !!u.free, false); if (u.free) mineFree++; }
            });
            var nextFree = bagFree < 5 && (bagN === 2 || (bagN >= 3 && bagN % 2 === 1));
            // dotted slots = what she is building toward: 2 + 2 until she has 4, then the next pair
            var target = Math.min(10, bagN < 4 ? 4 : bagN + (bagN % 2 ? 1 : 2));
            var freeT = Math.min(5, Math.floor(target / 2)), paidT = target - freeT;
            var paidDots = Math.max(0, paidT - (bagN - bagFree)), freeDots = Math.max(0, freeT - bagFree);
            for (var pd = 0; pd < paidDots; pd++) mkCell(null, false, false);
            for (var fd = 0; fd < freeDots; fd++) mkCell(null, true, false);
            state.bnBag = { n: bagN, free: bagFree, mineFree: mineFree, nextFree: nextFree };
          }
          card.appendChild(strip);
          var fShow = (on && state.bnBag && state.bnBag.mineFree) ? state.bnBag.mineFree : free;
          card.insertAdjacentHTML('beforeend', '<div class="tc-bn-perks"><div class="tc-bn-perk"><span><i>🎁</i>+ ' + fShow + ' free ' + (fShow > 1 ? nn[1] : nn[0]) + '</span><s>' + GG.money(unit * fShow) + '</s></div>' +
            (price >= 5000 ? '<div class="tc-bn-perk"><span><i>🚚</i>+ free delivery</span><s>$4</s></div>' : '') +
            (price >= 6000 ? '<div class="tc-bn-perk"><span><i>✨</i>+ a free full-size gift</span><b>free</b></div>' : '') + '</div>');
        }
        if (on) {
          var body = document.createElement('div');
          body.className = 'tc-body';
          if (t === 0 && state.shade >= 0) body.appendChild(buildShadeDropdown(0, state.shade, function (i) {
            state.shade = i;
            state.img = 0;
            render();
          }));
          if (t) {
            var picks = bnPicks(), filled = picks.length;
            var bagNow = state.bnBag ? state.bnBag.n : 0;
            var msg = bagNow ? (window.GG_BN_NEXT ? window.GG_BN_NEXT(bagNow).line : '') + ' ✦ or check out anytime' : 'tap a shade to add it to your bag';
            body.insertAdjacentHTML('beforeend', '<div class="tc-bn-pick">' + msg + '</div>');
            var chipsBox = document.createElement('div');
            chipsBox.className = 'gg-bnb-chips tc-chips';
            data.variants.forEach(function (v, vi) {
              var count = picks.filter(function (s) { return s === vi; }).length;
              var w = document.createElement('div');
              w.className = 'gg-bnb-chip' + (isOut(v) ? ' out' : '') + (count ? ' has' : '');
              w.innerHTML = '<button type="button" class="gg-bnb-add"' + (isOut(v) ? ' disabled' : '') + ' aria-label="add ' + v.shade + '">' +
                '<span class="gg-bnb-sw"' + (v.chip ? ' style="background-image:url(\'' + v.chip + '\')"' : '') + '>' + (count ? '<i>' + count + '</i>' : '') + '</span>' +
                '<span class="gg-bnb-sn">' + v.shade + '</span></button>' +
                (count ? '<button type="button" class="gg-bnb-min tc-x" aria-label="remove one ' + v.shade + '">✕</button>' : '');
              // a tap puts it straight in her bag, so the pinned bag, the savings and the delivery bar move at once
              w.querySelector('.gg-bnb-add').addEventListener('click', function () {
                if (bnPicks().length >= 10) { strip.classList.add('pulse'); setTimeout(function () { strip.classList.remove('pulse'); }, 900); return; }
                w.classList.add('busy');
                addItems([{ id: v.id, quantity: 1 }]).then(function () {
                  bnSyncFromCart(); state.shade = vi; state.img = 0; render();
                  // no popup on add any more: her bag opens when she taps check out (Ali 2026-11-03)
                }).catch(function (er) { w.classList.remove('busy'); alert((er && er.description) || 'something went wrong, gurl. try again?'); });
              });
              var x = w.querySelector('.tc-x');
              if (x) x.addEventListener('click', function () { bnRemoveOne(vi); });
              chipsBox.appendChild(w);
            });
            body.appendChild(chipsBox);
          }
          if (body.childNodes.length) card.appendChild(body);
        }
        tiersEl.appendChild(card);
      });
      tiersEl.insertAdjacentHTML('beforeend', '<a class="tc-mix" href="' + build + '">or mix with other products ✦ <u>build your bag →</u></a>');
      // the shades she already picked here travel with her: they go in the bag before she lands on build your bag
      var mix = tiersEl.querySelector('.tc-mix');
      mix.addEventListener('click', function (e) {
        var items = state.tier === 1 ? bnPendingItems() : [];
        if (!items.length) return;
        e.preventDefault();
        mix.textContent = 'bringing your shades ✦';
        var go = function () { window.location.href = mix.getAttribute('href'); };
        addItemsRaw(items).then(go, go);
      });
      if (slotsEl && !slotsEl.parentNode) tiersEl.appendChild(slotsEl);
    }

    function renderTiers() {
      if (window.GG_BN && data.type !== 'dual' && tiersEl && data.tierPrices && data.tierPrices.length >= 3) return renderTiersBN();
      if (!tiersEl || !data.tierPrices || data.tierPrices.length < 3) return;
      var TQ = data.tierQtys || TIER_QTY;
      // Tier three only exists if the Collection bundle does.
      var CB = data.collection;
      var allCount = (CB && CB.count > 0) ? CB.count : TQ[2];
      var allLabel = (CB && CB.label) ? CB.label : 'all ' + allCount + ' shades';
      var names = ['just one', 'any ' + TQ[1] + ' shades', allLabel];
      var subs = ['one shade, your pick', 'mix any ' + TQ[1] + ' shades', 'every shade in one bag'];
      if (window.GG_BN) {
        names = ['just one', 'buy 2, get 2 free', 'buy 3, get 3 free'];
        subs = ['one shade, your pick', 'pick any 4 shades', 'pick any 6 shades'];
      }
      var tags = [null, ['most popular', 'raspberry'], ['best value', 'gold']];
      tiersEl.classList.add('gg-tcards');
      if (slotsEl && slotsEl.parentNode) slotsEl.parentNode.removeChild(slotsEl);
      tiersEl.innerHTML = '';
      names.forEach(function (name, t) {
        if (t === 2 && !CB && !window.GG_BN) return;      // no bundle, no tier
        var price = (t === 2 && CB) ? CB.price : data.tierPrices[t];
        var qty = (t === 2) ? allCount : TQ[t];
        var save = (t === 2 && CB)
          ? Math.round((data.tierPrices[0] * allCount - CB.price) / 100)
          : data.tierSaves[t];
        var orig = (t === 0) ? (data.compareAtCents || 0) : data.tierPrices[0] * qty;
        if (t === 0 && orig > price) save = Math.round((orig - price) / 100);
        var ship = price >= 5000, gift = price >= 6000;
        // Say the deal once, in words: the saving in raspberry on the line under
        // the name, and only the gift earns a chip. Just one shows no saving so
        // the bundles read as the deal.
        var stickers = '';
        var chip = gift ? '<span class="tc-chip tc-chip-gift">🎁 free gift</span>' : '';
        var sub = t === 0 ? subs[0]
          : (save > 0 ? '<b class="tc-save">save $' + save + '</b>' : subs[t]) + (ship ? ' + free delivery' : '');
        if (window.GG_BN && t > 0) sub = '<b class="tc-save">' + (t === 1 ? 2 : 3) + ' free</b> \u00B7 ' + subs[t] + (ship ? ' + free delivery' : '');
        var on = t === state.tier;
        var card = document.createElement('div');
        card.className = 'gg-tcard' + (on ? ' on' : '');
        var head = document.createElement('button');
        head.type = 'button';
        head.className = 'gg-tier tc-head';
        head.setAttribute('aria-pressed', on ? 'true' : 'false');
        head.innerHTML =
          (tags[t] ? '<span class="tc-tag tc-tag-' + tags[t][1] + '">' + tags[t][0] + '</span>' : '') +
          '<span class="tc-radio" aria-hidden="true"></span>' +
          '<span class="tc-main"><span class="tc-top"><span class="tc-name">' + capFirst(name) + '</span>' + chip + '</span>' +
            '<span class="tc-sub">' + sub + '</span></span>' +
          '<span class="tc-right"><span class="tc-price">' + GG.money(price) +
            (orig > price ? '<s class="tc-orig">' + GG.money(orig) + '</s>' : '') + '</span>' +
            (qty > 1 ? '<span class="tc-each">' + GG.money(Math.round(price / qty)) + ' each</span>' : '') + '</span>';
        head.addEventListener('click', function () {
          if (state.tier === t) return;
          state.tier = t;
          state.slots = [];
          // All shades means all of them. Nothing to pick.
          if (t === 1 || (window.GG_BN && t === 2)) {
            for (var s = 0; s < TQ[t]; s++) state.slots.push(null);
          }
          if (state.shade < 0) state.shade = 0;
          render();
        });
        card.appendChild(head);
        if (on) {
          var body = document.createElement('div');
          body.className = 'tc-body';
          // Just one: her shade, and its photos, right here, so she never scrolls back up to the gallery.
          if (t === 0 && state.shade >= 0) body.appendChild(buildShadeDropdown(0, state.shade, function (i) {
            state.shade = i;
            state.img = 0;
            render();
          }));
          if ((t === 1 || (window.GG_BN && t === 2)) && slotsEl) body.appendChild(slotsEl);
          if (t === 2 && !window.GG_BN) body.insertAdjacentHTML('beforeend', '<div class="tc-perk"><i>✨</i><span class="tc-perk-txt"><b>all ' + allCount + ' shades in one bag</b><span>one of every shade, nothing to choose</span></span></div>');
          if (gift) body.insertAdjacentHTML('beforeend', '<div class="tc-perk"><i>🎁</i><span class="tc-perk-txt"><b>a mystery full-size gift</b><span>a glitter gurl product worth $15 to $22, on us</span></span><em>free</em></div>');
          if (ship) body.insertAdjacentHTML('beforeend', '<div class="tc-perk"><i>🚚</i><span class="tc-perk-txt"><b>free delivery</b><span>anywhere in Lebanon, pay cash when it arrives</span></span><em>free</em></div>');
          if (body.childNodes.length) card.appendChild(body);
        }
        if (stickers) { card.classList.add('has-st'); card.insertAdjacentHTML('beforeend', '<span class="tc-stickers">' + stickers + '</span>'); }
        tiersEl.appendChild(card);
      });
      // Off-screen home for the slots when the open card does not use them.
      if (slotsEl && !slotsEl.parentNode) tiersEl.appendChild(slotsEl);
    }

    function renderChips() {
      if (!chipsEl) return;
      chipsEl.innerHTML = '';
      data.variants.forEach(function (v, i) {
        var b = document.createElement('button');
        var out = isOut(v);
        b.className = 'gg-chip' + (i === state.shade ? ' on' : '') + (out ? ' soldout' : '');
        var visual = v.chip ? '<span class="c-img" style="background-image:url(\'' + v.chip + '\')"></span>' : '<span class="c-dot" style="background:' + (v.hex || '#F4CDCE') + '"></span>';
        b.innerHTML = visual + v.shade + (out ? '<span class="c-out">sold out</span>' : '');
        if (out) b.setAttribute('aria-label', v.shade + ' ✦ sold out');
        b.addEventListener('click', function () { state.shade = i; state.img = 0; render(); });
        chipsEl.appendChild(b);
      });
    }

    var SLOT_ORD = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
    function buildShadeDropdown(slotIdx, pick, onPick, isFree) {
      var wrap = document.createElement('div');
      wrap.className = 'gg-dd-wrap';
      var box = document.createElement('div');
      box.className = 'gg-dd-box';
      var control = document.createElement('button');
      control.type = 'button';
      control.className = 'gg-dd-control' + (pick === null ? ' empty' : '');
      if (pick === null) {
        control.innerHTML = '<span class="dd-name">select your ' + SLOT_ORD[slotIdx] + ' shade</span><span class="dd-change">▾</span>';
      } else {
        var pv = data.variants[pick];
        // ggCards: the selected row shows her lips in that shade, not the glitter swatch.
        pv = Object.assign({}, pv, { chip: (galleryFor(pv.shade)[0] || {}).src || pv.chip });
        control.innerHTML = '<span class="dd-sw"' + (pv.chip ? ' style="background-image:url(\'' + pv.chip + '\')"' : '') + '></span>' +
          '<span class="dd-name">' + pv.shade + '</span><span class="dd-change">change ▾</span>';
      }
      if (isFree) { control.classList.add('dd-is-free'); control.insertAdjacentHTML('beforeend', '<span class="dd-free">free 🎁</span>'); }
      box.appendChild(control);
      var menu = document.createElement('div');
      menu.className = 'gg-dd-menu';
      menu.hidden = true;
      data.variants.forEach(function (v, i) {
        var opt = document.createElement('button');
        var vOut = isOut(v);
        opt.type = 'button';
        opt.className = 'gg-dd-opt' + (pick === i ? ' on' : '') + (vOut ? ' soldout' : '');
        opt.innerHTML = '<span class="dd-sw"' + (v.chip ? ' style="background-image:url(\'' + v.chip + '\')"' : '') + '></span><span class="dd-name">' + v.shade + '</span>' +
          (vOut ? '<span class="dd-out">sold out</span>' : (pick === i ? '<span class="dd-tick">✓</span>' : ''));
        if (vOut) opt.disabled = true;
        else opt.addEventListener('click', function () { onPick(i); });
        menu.appendChild(opt);
      });
      box.appendChild(menu);
      wrap.appendChild(box);
      if (pick !== null && isFree === undefined) {
        var car = document.createElement('div');
        car.className = 'gg-shade-carousel';
        galleryFor(data.variants[pick].shade).forEach(function (m) {
          var cell = document.createElement('div');
          cell.className = 'gg-carousel-cell';
          cell.style.backgroundImage = "url('" + m.src + "')";
          if (/sticker/i.test(m.alt)) cell.insertAdjacentHTML('beforeend', '<span class="gg-cell-gift">🎁 free sticker pack</span>');
          car.appendChild(cell);
        });
        wrap.appendChild(car);
      }
      control.addEventListener('click', function () {
        var willOpen = menu.hidden;
        slotsEl.querySelectorAll('.gg-dd-menu').forEach(function (m) { m.hidden = true; });
        slotsEl.querySelectorAll('.gg-dd-control').forEach(function (c) { c.classList.remove('open'); });
        if (willOpen) { menu.hidden = false; control.classList.add('open'); }
      });
      return wrap;
    }
    function renderSlots() {
      if (!slotsEl) return;
      slotsEl.innerHTML = '';
      if (window.GG_BN || state.tier !== 1) { slotsEl.hidden = true; return; }
      slotsEl.hidden = false;
      state.slots.forEach(function (pick, slotIdx) {
        slotsEl.appendChild(buildShadeDropdown(slotIdx, pick, function (i) {
          state.slots[slotIdx] = i;
          state.shade = i;
          state.img = 0;
          render();
        }, window.GG_BN ? slotIdx > state.tier : undefined));
      });
      if (!window.GG_BN && state.tier === 1 && state.slots.every(function (s) { return s !== null; })) {
        var nudge = document.createElement('button');
        nudge.type = 'button';
        nudge.className = 'gg-card-nudge gg-nudge-btn';
        nudge.textContent = 'gurl!! any 3 shades is the best price ✦ tap to upgrade →';
        nudge.addEventListener('click', function () {
          state.tier = 2;
          state.slots = [];
          render();
        });
        slotsEl.appendChild(nudge);
      }
    }

    function renderDualChips() {
      [{ el: chipsEl, values: data.options.values1, sel: 'sel1', chips: data.options.chips1, avail: data.options.avail1 },
       { el: chips2El, values: data.options.values2, sel: 'sel2', chips: data.options.chips2, avail: data.options.avail2 }].forEach(function (group) {
        if (!group.el) return;
        group.el.innerHTML = '';
        group.values.forEach(function (val, i) {
          var b = document.createElement('button');
          var out = group.avail && group.avail[i] === false;
          b.className = 'gg-chip' + (state[group.sel] === i ? ' on' : '') + (out ? ' soldout' : '');
          var chip = group.chips && group.chips[i];
          var visual = chip ? '<span class="c-img" style="background-image:url(\'' + chip + '\')"></span>' : '<span class="c-dot" style="background:#F4CDCE"></span>';
          b.innerHTML = visual + val + (out ? '<span class="c-out">sold out</span>' : '');
          if (out) b.setAttribute('aria-label', val + ' ✦ sold out');
          b.addEventListener('click', function () { state[group.sel] = i; state.lastSel = group.sel; state.img = 0; render(); });
          group.el.appendChild(b);
        });
      });
    }

    function addToBag() {
      if (state.soldOut) return;
      if (window.GG_BN && state.tier === 1 && bnCartCount() > 0) { if (window.GG_BN_BAG) window.GG_BN_BAG(); else window.location.href = '/checkout'; return; }
      if (data.type !== 'dual' && (state.tier === 1 || (window.GG_BN && state.tier === 2)) && !state.slots.every(function (s) { return s !== null; })) {
        var slotsBox = window.GG_BN ? document.querySelector('.gg-tcard.on') : document.getElementById('gg-slots');
        if (slotsBox) {
          slotsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          slotsBox.classList.add('pulse');
          setTimeout(function () { slotsBox.classList.remove('pulse'); }, 1700);
        }
        return;
      }
      var items;
      if (data.type === 'dual') {
        if (!state.resolved) return;
        items = [{ id: state.resolved, quantity: 1 }];
      } else if (state.tier === 0) {
        items = [{ id: data.variants[state.shade].id, quantity: 1 }];
      } else if (state.tier === 2 && data.collection) {
        // One bundle line, priced at the collection price, and the
        // components come off the shelf properly.
        items = [{ id: data.collection.id, quantity: 1 }];
      } else {
        var counts = {};
        state.slots.forEach(function (p) { var id = data.variants[p].id; counts[id] = (counts[id] || 0) + 1; });
        items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
        if (window.GG_BN && state.tier === 1) { items = bnPendingItems(); if (!items.length) { if (window.GG_BN_BAG) window.GG_BN_BAG(); else window.location.href = '/checkout'; return; } }
      }
      addItems(items).then(function () {
        if (state.tier > 0) {
          state.slots = [];
          if (window.GG_BN) { bnSyncFromCart(); state.bnPick = null; }
          else for (var s = 0; s < (data.tierQtys || TIER_QTY)[state.tier]; s++) state.slots.push(null);
        }
        render();
        if (window.GG_BN_ADDED) window.GG_BN_ADDED(); else openDrawer();
      }).catch(function (e) { alert((e && e.description) || 'something went wrong, gurl. try again?'); });
    }
    ctas.forEach(function (btn) { btn.addEventListener('click', addToBag); });
    if (window.GG_BN) document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.classList.contains('tc-mix') || a.target === '_blank') return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href) || (a.host && a.host !== location.host)) return;
      var items = state.tier === 1 ? bnPendingItems() : [];
      if (!items.length) return;
      e.preventDefault();
      var go = function () { window.location.href = a.href; };
      addItemsRaw(items).then(go, go);
    }, true);
    // on arrival the picker shows the shades of this product already in her bag
    if (window.GG_BN) fetchCart().then(function () { if (state.tier === 1) { bnSyncFromCart(); render(); } });
    if (window.GG_BN) {
      var bnPrevA = window.__ggAnnounceRefresh;
      window.__ggAnnounceRefresh = function () {
        if (bnPrevA) bnPrevA.apply(this, arguments);
        if (state.tier !== 1) return;
        bnSyncFromCart();
        render();   // the button label depends on the whole bag, so always redraw
      };
    }
    render();
  }

  function initSetOffer() {
    var link = document.getElementById('gg-checkout-btn');
    var modal = document.getElementById('gg-setoffer');
    if (!link || !modal) return;
    var offered = false;
    link.addEventListener('click', function (e) {
      var c = cartState;
      if (!c || offered) return;
      if (window.GG_BN && window.GG_BN_GATE && window.GG_BN_GATE(c, function () { window.location.href = link.href; })) { e.preventDefault(); return; }
      // Only interrupt when the gift is genuinely within reach, never
      // once she already has it and never when it is far away.
      var t = c.total_price || 0;
      if (t >= GIFT_CENTS || t < GIFT_CENTS - 2500) return;
      e.preventDefault();
      offered = true;
      modal.hidden = false;
      document.getElementById('gg-setoffer-reject').onclick = function () {
        modal.hidden = true;
        window.location.href = link.href;
      };
      document.getElementById('gg-setoffer-accept').onclick = function () {
        modal.hidden = true;
        var note = document.getElementById('gg-setoffer-note');
        if (note) note.hidden = false;
        // She said keep shopping, so get the bag out of her way.
        closeDrawer();
      };
    });
  }

  // ggSwatches: shop-wide shade icons (bag rows, upsells) use the new swatches and marker dots.
  function ggApplySwatches() {
    var shop = (window.GG_SHOP && window.GG_SHOP.products) || {};
    var sw = window.GG_SWATCHES || {}, hx = window.GG_SHADE_HEX_ALL || {};
    Object.keys(shop).forEach(function (h) {
      (shop[h].variants || []).forEach(function (v) {
        if (sw[h] && sw[h][v.title]) v.chip = sw[h][v.title];
        else if (hx[h] && hx[h][v.title]) v.chip = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"><rect width="1" height="1" fill="' + hx[h][v.title] + '"/></svg>');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    ggApplySwatches();
    initHeader();
    initAccordions();
    initPdp();
    initSetOffer();
    fetchCart();
  });
})();


/* ggSwipe: every gallery and carousel gets left/right arrows and can be
   swiped (finger) or dragged (mouse). Galleries step through their own
   thumbnails or dots, so each keeps one source of truth for what shows. */
(function () {
  var MAIN = '.gg-gallery-main, .ggb-sg-main, .gg-peek-img';
  function navFor(main) {
    if (main.classList.contains('gg-peek-img')) {
      var card = main.closest('.gg-peek-card'); var d = card && card.querySelector('.gg-peek-dots');
      return d ? [].slice.call(d.querySelectorAll('button')) : [];
    }
    var n = main.nextElementSibling;
    while (n && !(n.classList.contains('gg-thumbs') || n.classList.contains('ggb-sg-thumbs') || n.classList.contains('gg-thumbs-wrap'))) n = n.nextElementSibling;
    if (n && n.classList.contains('gg-thumbs-wrap')) n = n.querySelector('.gg-thumbs');
    return n ? [].slice.call(n.querySelectorAll('button')) : [];
  }
  function step(main, dir) {
    var btns = navFor(main); if (btns.length < 2) return;
    var cur = btns.findIndex(function (b) { return b.classList.contains('on'); }); if (cur < 0) cur = 0;
    btns[(cur + dir + btns.length) % btns.length].click();
  }
  function scrollCar(car, dir) {
    var cell = car.firstElementChild; var w = cell ? cell.getBoundingClientRect().width + 8 : 140;
    car.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
  }
  function arrows(host, onStep) {
    if (host.querySelector(':scope > .gg-arr')) return;
    ['prev', 'next'].forEach(function (k) {
      var a = document.createElement('button'); a.type = 'button';
      a.className = 'gg-arr gg-arr-' + k; a.setAttribute('aria-label', k === 'prev' ? 'previous' : 'next');
      a.innerHTML = k === 'prev' ? '&#8249;' : '&#8250;';
      a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onStep(k === 'prev' ? -1 : 1); });
      ['touchstart', 'touchend', 'pointerdown'].forEach(function (ev) { a.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
      host.appendChild(a);
    });
  }
  function scan() {
    document.querySelectorAll(MAIN).forEach(function (m) {
      if (navFor(m).length > 1) { m.classList.add('gg-has-arr'); arrows(m, function (d) { step(m, d); }); }
    });
    document.querySelectorAll('.gg-shade-carousel').forEach(function (car) {
      var wrap = car.parentNode;
      if (!wrap.classList.contains('gg-car-wrap')) {
        var w = document.createElement('div'); w.className = 'gg-car-wrap';
        car.parentNode.insertBefore(w, car); w.appendChild(car); wrap = w;
      }
      arrows(wrap, function (d) { scrollCar(car, d); });
    });
  }
  var pending = false;
  new MutationObserver(function () { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; scan(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scan); scan();

  // finger swipe (the bag peek has its own finger swipe already)
  var x0 = null, y0 = null, host = null;
  document.addEventListener('touchstart', function (e) {
    var m = e.target.closest && e.target.closest('.gg-gallery-main, .ggb-sg-main');
    if (!m || e.touches.length !== 1) { host = null; return; }
    host = m; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!host) return;
    var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0, m = host; host = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
    step(m, dx < 0 ? 1 : -1);
  }, { passive: true });
  // mouse drag on desktop, galleries and the bag peek
  var mx = null, mHost = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var m = e.target.closest && e.target.closest(MAIN); if (!m) return;
    mHost = m; mx = e.clientX;
  });
  document.addEventListener('pointerup', function (e) {
    if (!mHost) return; var m = mHost, dx = e.clientX - mx; mHost = null;
    if (Math.abs(dx) < 40) return;
    m.__ggDragged = true; setTimeout(function () { m.__ggDragged = false; }, 0);
    step(m, dx < 0 ? 1 : -1);
  });
  // a drag must not also count as a click on the image
  document.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest(MAIN);
    if (m && m.__ggDragged) { e.stopPropagation(); e.preventDefault(); }
  }, true);
})();


/* ── search: header panel with live (predictive) results ─────────── */
(function () {
  var btn = document.getElementById('gg-search-btn');
  var panel = document.getElementById('gg-search-panel');
  if (!btn || !panel) return;
  var input = document.getElementById('gg-search-input');
  var results = document.getElementById('gg-search-results');
  var pop = document.getElementById('gg-search-pop');
  var form = document.getElementById('gg-search-form');
  var timer = null, seq = 0;
  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; }); }
  function money(v) { var n = parseFloat(v); if (isNaN(n)) return ''; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function open() {
    panel.hidden = false; btn.setAttribute('aria-expanded', 'true');
    var mnav = document.getElementById('gg-nav-mobile'), burger = document.getElementById('gg-burger');
    if (mnav && mnav.classList.contains('open')) { mnav.classList.remove('open'); if (burger) burger.textContent = '☰'; }
    setTimeout(function () { input.focus(); }, 30);
  }
  function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
  btn.addEventListener('click', function (e) { e.stopPropagation(); panel.hidden ? open() : close(); });
  document.getElementById('gg-search-close').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { close(); btn.focus(); } });
  document.addEventListener('click', function (e) { if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) close(); });

  panel.addEventListener('click', function (e) {
    var chip = e.target.closest('.gg-search-chip[data-q]');
    if (chip) { input.value = chip.getAttribute('data-q'); run(); input.focus(); }
  });
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
  form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });

  function run() {
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; pop.hidden = false; return; }
    pop.hidden = true;
    var my = ++seq;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title';
    fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (data) {
      if (my !== seq) return;
      render(q, (data.resources && data.resources.results) || {});
    }).catch(function () { if (my === seq) results.innerHTML = '<p class="gg-search-empty">search is taking a nap, try again in a sec ✦</p>'; });
  }

  function render(q, res) {
    var ql = q.toLowerCase(), html = '';
    var colls = (res.collections || []).filter(function (c) { return c.handle !== 'all' && c.handle !== 'frontpage'; });
    if (colls.length) {
      html += '<div class="gg-search-label">collections</div><div class="gg-search-coll">' +
        colls.slice(0, 4).map(function (c) { return '<a class="gg-search-chip" href="' + esc(c.url) + '">' + esc(String(c.title).toLowerCase()) + '</a>'; }).join('') + '</div>';
    }
    // names that contain the search come first, then names that contain every word, then the rest
    var words = ql.split(/\s+/).filter(Boolean);
    function score(p) { var t = String(p.title).toLowerCase(); if (t.indexOf(ql) > -1) return 0; if (words.every(function (w) { return t.indexOf(w) > -1; })) return 1; if ((p.variants || []).length) return 2; return 3; }
    var prods = (res.products || []).map(function (p, i) { return { p: p, s: score(p), i: i }; })
      .sort(function (a, b) { return a.s - b.s || a.i - b.i; }).map(function (x) { return x.p; }).slice(0, 8);
    if (prods.length) {
      html += '<div class="gg-search-label">products</div>';
      prods.forEach(function (p) {
        // when the search matched a shade name, open that shade and show its photo
        var v = (p.variants || []).filter(function (x) { return x.title && x.title.toLowerCase().indexOf(ql) > -1; })[0];
        if (v && v.title.indexOf(' / ') > -1) v = null; // bundles: a preset combo, not a shade
        var href = v && v.url ? v.url : p.url;
        var pic = (v && v.image) || p.image || (p.featured_image && p.featured_image.url) || '';
        var price = v ? v.price : (p.price_min || p.price);
        var was = v ? v.compare_at_price : (p.compare_at_price_min || p.compare_at_price_max);
        html += '<a class="gg-search-row" href="' + esc(href) + '">' +
          (pic ? '<img src="' + esc(sized(pic, 160)) + '" alt="" loading="lazy">' : '<span class="gg-search-noimg"></span>') +
          '<span><span class="gg-search-name">' + esc(p.title) + '</span>' +
          (v && v.title !== 'Default Title' ? '<span class="gg-search-shade">shade: ' + esc(v.title) + '</span>' : '') +
          '</span>' +
          '<span class="gg-search-price">' + (parseFloat(was) > parseFloat(price) ? '<s>' + money(was) + '</s>' : '') + money(price) + '</span></a>';
      });
      html += '<a class="gg-btn-line gg-search-all" href="/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last">see all results</a>';
    }
    if (!colls.length && !prods.length) {
      html = '<p class="gg-search-empty">nothing sparkly for "' + esc(q) + '" yet, gurl. try one of these:</p>';
      pop.hidden = false;
    }
    results.innerHTML = html;
  }
})();


/* ── product cards: keep the dots in step with the swipe ── */
(function () {
  function bind() {
    document.querySelectorAll('.gg-card-track:not([data-bound])').forEach(function (t) {
      t.setAttribute('data-bound', '1');
      var dots = t.parentNode.querySelectorAll('.gg-card-dots i');
      t.addEventListener('scroll', function () {
        var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  new MutationObserver(bind).observe(document.documentElement, { childList: true, subtree: true });
})();


/* PDP thumbnails: one row, 4 at a time, arrows outside the strip when there are more. */
function ggThumbRow(row) {
  var wrap = row.parentNode;
  if (!wrap.classList.contains('gg-thumbs-wrap')) {
    wrap = document.createElement('div'); wrap.className = 'gg-thumbs-wrap';
    row.parentNode.insertBefore(wrap, row); wrap.appendChild(row);
    ['prev', 'next'].forEach(function (k) {
      var a = document.createElement('button'); a.type = 'button';
      a.className = 'gg-tarr gg-tarr-' + k; a.setAttribute('aria-label', k === 'prev' ? 'previous photos' : 'more photos');
      a.innerHTML = k === 'prev' ? '&#8249;' : '&#8250;';
      a.addEventListener('click', function (e) { e.preventDefault(); row.scrollBy({ left: (k === 'prev' ? -1 : 1) * row.clientWidth, behavior: 'smooth' }); });
      wrap.appendChild(a);
    });
    row.addEventListener('scroll', function () { ggThumbEdges(row); }, { passive: true });
    window.addEventListener('resize', function () { ggThumbEdges(row); });
  }
  wrap.classList.toggle('gg-thumbs-many', row.children.length > 4);
  var on = row.querySelector('button.on');
  if (on) {
    var l = on.offsetLeft - row.offsetLeft, r = l + on.offsetWidth;
    if (l < row.scrollLeft) row.scrollLeft = l;
    else if (r > row.scrollLeft + row.clientWidth) row.scrollLeft = r - row.clientWidth;
  }
  ggThumbEdges(row);
}
function ggThumbEdges(row) {
  var w = row.parentNode; if (!w) return;
  w.classList.toggle('gg-at-start', row.scrollLeft <= 2);
  w.classList.toggle('gg-at-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
}
